<template>
  <main class="login">
    <rl-login-card>
      <h4>Logging in...</h4>
      <el-progress :indeterminate="true" :duration="2" :percentage="100" :show-text="false" />
    </rl-login-card>
  </main>
</template>
